import { WaitingPeriod } from '@zorro/clients';
import { waitingPeriodLabelConfig } from '@zorro/common-utils';
import { Select, type SelectProps } from '@zorro/design-system/v2/Select';
import { LabelWithTooltip } from '@zorro/web/design-system';
import { ForwardedRef, forwardRef } from 'react';
import { ControllerRenderProps, Path } from 'react-hook-form';

export const waitingPeriodOptions = [
  WaitingPeriod.NONE,
  WaitingPeriod.THIRTY_DAYS,
  WaitingPeriod.SIXTY_DAYS,
].map((waitingPeriod) => ({
  label: waitingPeriodLabelConfig[waitingPeriod],
  value: waitingPeriod,
}));

type WaitingPeriodFieldValues = { waitingPeriod?: WaitingPeriod | null };
type Props<T extends WaitingPeriodFieldValues, U extends Path<T>> = Omit<
  ControllerRenderProps<T, U>,
  'ref'
> & {
  selectProps?: SelectProps;
  isReadOnly?: boolean;
  isRequired?: boolean;
};

export const WaitingPeriodInput = forwardRef(
  <T extends WaitingPeriodFieldValues, U extends Path<T>>(
    { selectProps, isRequired, isReadOnly, ...field }: Props<T, U>,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <Select
        {...field}
        isReadOnly={isReadOnly}
        {...selectProps}
        ref={ref}
        size="lg"
        label={
          <LabelWithTooltip
            label="Waiting period"
            tooltipLabel="Coverage starts on the 1st of the month following the specified waiting period"
            isRequired={isRequired}
          />
        }
        placeholder="Waiting period"
        data={waitingPeriodOptions}
      />
    );
  }
);

WaitingPeriodInput.displayName = 'WaitingPeriodInput';
